import {makeAutoObservable} from "mobx";

export const TermsOfUseUrl = 'https://spectrum-tank-5ab.notion.site/812584ac564a4960b141d0678edfcf7c?pvs=4';
export const TermsOfPrivacyUrl = 'https://spectrum-tank-5ab.notion.site/de444839176d421aaf8d03d841fd382a?pvs=4';

const logPrefix  = "[UserStore]"
export default class UserStore {
    constructor(props) {
        this.userRepository = props.userRepository;

        this.init();

        makeAutoObservable(this);
    }

    init = () => {
        this.isUserDeviceListLoading = false;
        this.isUserDeviceLoading = false;
        this.isDeleteUserDeviceLoading = false;
        this.isUserWeekListLoading = false;
        this.isUserDashboardLoading = false;

        this.selectedDevice = '';
        this.newSelectedDevice = '';
        this.userDeviceList = [];
        this.userDeviceDetail = null;

        this.selectedWeekOfMonth = '';
        this.userWeekOfMonthList = [];

        this.userDashboardData = '';

        this.newPokoroDialogOpen = false;

        this.userPushAgreement = '';
    }

    get getIsLoading() {
        return this.isUserDeviceListLoading || this.isUserDeviceLoading || this.isUserWeekListLoading || this.isUserDashboardLoading;
    };

    setSelectedDevice = (device) => {
        this.selectedDevice = device;
    }

    /** 서버 재조회 전에 호출 — 이전 화면에서 남은 userDeviceList로 PokoroListSlide 등이 선택을 덮어쓰는 것을 막음 */
    clearCachedUserDeviceList = () => {
        this.userDeviceList = [];
    }

    setSelectedDeviceById = (deviceId) => {
        const device = this.userDeviceList.find(d => d.deviceId === deviceId);
        if (device) {
            this.selectedDevice = device;
        } else {
            this.selectedDevice = {
                deviceId: deviceId,
                deviceName: deviceId
            };
        }
    }

    getDeviceNameById = (deviceId) => {
        const device = this.userDeviceList.find(d => d.deviceId === deviceId);
        if (device) {
            return device.deviceName;
        } else {
            return deviceId;
        }
    }

    setNewSelectedDevice = (device) => {
        this.newSelectedDevice = device;
    }

    setSelectedWeekOfMonth = (weekOfMonth) => {
        this.selectedWeekOfMonth = weekOfMonth;
    }

    * getUserDeviceList(userId, isSetSelectedDevice, callback) {
        try {
            console.log(logPrefix, 'Start getUserDeviceList.');
            this.isUserDeviceListLoading = true;

            const response = yield this.userRepository.getUserDeviceList(userId);
            const list = Array.isArray(response.data) ? response.data : [];
            if (list.length > 0) {
                this.userDeviceList = list;

                if (isSetSelectedDevice) {
                    const firstWithProfile = this.userDeviceList.find((d) => d.profile != null);
                    this.selectedDevice = firstWithProfile ?? this.userDeviceList[0];
                }
            } else {
                this.userDeviceList = [];
                if (isSetSelectedDevice) {
                    this.selectedDevice = '';
                }
            }

            this.isUserDeviceListLoading = false;
            console.log(logPrefix, 'Finished getUserDeviceList.');

            if (this.selectedDevice !== '') {
                callback && callback(userId, this.selectedDevice.deviceId);
            }
        } catch(e) {
            this.selectedDevice = '';
            this.userDeviceList = [];
            console.log(logPrefix, 'Failed getUserDeviceList. error: ' + e);
        } finally {
            this.isUserDeviceListLoading = false;
        }
    }

    * getUserDevice(userId, deviceId, callback) {
        try {
            console.log(logPrefix, 'Start getUserDevice.');
            this.isUserDeviceLoading = true;

            const response = yield this.userRepository.getUserDevice(userId, deviceId);
            this.userDeviceDetail = response.data;

            console.log(logPrefix, 'Finished getUserDevice.');
            callback && callback(response.data);
        } catch(e) {
            this.userDeviceDetail = null;
            console.log(logPrefix, 'Failed getUserDevice. error: ' + e);
        } finally {
            this.isUserDeviceLoading = false;
        }
    }

    * getUserWeekOfMonthList(userId, callback) {
        try {
            console.log(logPrefix, 'Start getUserWeekOfMonthList.');
            this.isUserWeekListLoading = true;

            const response = yield this.userRepository.getUserWeekList(userId, this.selectedDevice.deviceId);
            if (response.data.length > 0) {
                this.userWeekOfMonthList = response.data;
                this.selectedWeekOfMonth = this.userWeekOfMonthList[0];
            }

            this.isUserWeekListLoading = false;
            console.log(logPrefix, 'Finished getUserWeekOfMonthList.');

            if (this.selectedWeekOfMonth !== '') {
                callback && callback(userId);
            }
        } catch(e) {
            this.selectedWeekOfMonth = '';
            this.userWeekOfMonthList = [];
            console.log(logPrefix, 'Failed getUserWeekOfMonthList. error: ' + e);
        } finally {
            this.isUserWeekListLoading = false;
        }
    }

    * getUserDashboard(userId, callback) {
        try {
            console.log(logPrefix, 'Start getUserDashboard.');
            this.isUserDashboardLoading = true;

            let url = `${userId}/dashboard?deviceId=${this.selectedDevice.deviceId}&year=${this.selectedWeekOfMonth.year}&month=${this.selectedWeekOfMonth.month}&week=${this.selectedWeekOfMonth.week}`;
            const response = yield this.userRepository.getUserDashboard(url);

            this.userDashboardData = response.data;

            this.isUserDashboardLoading = false;
            console.log(logPrefix, 'Finished getUserDashboard.');

            callback && callback();
        } catch(e) {
            this.userDashboardData = '';
            console.log(logPrefix, 'Failed getUserDashboard. error: ' + e);
        } finally {
            this.isUserDashboardLoading = false;
        }
    }

    * updatePenName(userId, deviceId, penName, callback) {
        try {
            console.log(logPrefix, 'Start updatePenName.');

            const param = {
                deviceName: penName
            }

            yield this.userRepository.updatePenName(userId, deviceId, param);

            console.log(logPrefix, 'Finished updatePenName.');

            callback && callback();
        } catch(e) {
            console.log(logPrefix, 'Failed updatePenName. error: ' + e);
        }
    }

    * deleteUser(userId, callback) {
        try {
            console.log(logPrefix, 'Start deleteUser.');

            yield this.userRepository.deleteUser(userId);

            console.log(logPrefix, 'Finished deleteUser.');

            callback && callback();
        } catch(e) {
            console.log(logPrefix, 'Failed deleteUser. error: ' + e);
        }
    }

    * getUserPushAgreement(userId, callback) {
        try {
            console.log(logPrefix, 'Start getUserPushAgreement.');

            const response = yield this.userRepository.getUserPushAgreement(userId);
            this.userPushAgreement = response.data;

            console.log(logPrefix, 'Finished getUserPushAgreement.');

            callback && callback();
        } catch(e) {
            console.log(logPrefix, 'Failed getUserPushAgreement. error: ' + e);
        }
    }

    * updateUserPushAgreement(userId, isAgreed, callback) {
        try {
            console.log(logPrefix, 'Start updateUserPushAgreement.');

            const param = {
                isAgreed: isAgreed
            }

            const response = yield this.userRepository.updateUserPushAgreement(userId, param);
            this.userPushAgreement = response.data;

            console.log(logPrefix, 'Finished updateUserPushAgreement.');

            callback && callback();
        } catch(e) {
            console.log(logPrefix, 'Failed updateUserPushAgreement. error: ' + e);
        }
    }

    * updateConnectedDevice(userId, deviceId, callback) {
        try {
            console.log(logPrefix, 'Start updateConnectedDevice.');

            yield this.userRepository.updateConnectedDevice(userId, deviceId);

            console.log(logPrefix, 'Finished updateConnectedDevice.');

            callback && callback();
        } catch(e) {
            console.log(logPrefix, 'Failed updateConnectedDevice. error: ' + e);
        }
    }

    deleteUserDeviceData = async (userId, deviceId) => {
        try {
            console.log(logPrefix, 'Start deleteUserDeviceData.');
            this.isDeleteUserDeviceLoading = true;
            await this.userRepository.deleteUserDeviceData(userId, deviceId);
            console.log(logPrefix, 'Finished deleteUserDeviceData.');
        } finally {
            this.isDeleteUserDeviceLoading = false;
        }
    }

    getUnlinkedDeviceProfileExists = async (userId) => {
        try {
            const response = await this.userRepository.getUnlinkedDeviceProfileExists(userId);
            return response.data;
        } catch (e) {
            console.log(logPrefix, 'Failed getUnlinkedDeviceProfileExists. error: ' + e);
            throw e;
        }
    }

    getUserDeviceProfileExists = async (userId, deviceId) => {
        try {
            const response = await this.userRepository.getUserDeviceProfileExists(userId, deviceId);
            return response.data;
        } catch (e) {
            console.log(logPrefix, 'Failed getUserDeviceProfileExists. error: ' + e);
            throw e;
        }
    }
}
